module.exports = __webpack_public_path__ + "img/cl.1cc139d8.svg";